import { colors } from 'fitify-ui'
import { biggerPhone, phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${phone(css`
    gap: 16px;
  `)};
`

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;

  ${biggerPhone(css`
    flex-direction: column;
    gap: 24px;
  `)};
`

export const StyledVideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  min-width: 0;
  max-width: 70%;
  flex: 1;
  padding: 12px;
  border-radius: 16px;
  aspect-ratio: 4 / 3;
  background-color: ${colors.White};

  ${biggerPhone(css`
    width: 100%;
    max-width: 100%;
    padding: 8px;
    border-radius: 12px;
  `)};
`

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const StyledThumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const StyledInfo = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`
